module.exports = __webpack_public_path__ + "img/u172.8f660927.png";